import { ReactNode, useEffect, useState } from 'react'

import { DefaultEventsMap } from '@socket.io/component-emitter'
import { Socket } from 'socket.io-client'

import { WebSocketContext } from './context'
import { connect } from '~/services/websocket.client.ts'
import { UserInfo } from '~/types/user.ts'

export const WebSocketProvider = ({
  children,
  user,
}: {
  children: ReactNode,
  user?: UserInfo,
}) => {
  const { userId, sessionId } = user || {}

  const [socket, setSocket] =
    useState<Socket<DefaultEventsMap, DefaultEventsMap>>()

  useEffect(() => {
    if (!userId || !sessionId) {
      return
    }

    const connectedSocket = connect({
      auth: { userId, sessionId },
    })
    setSocket(connectedSocket)

    return () => {
      if (!userId || !sessionId) {
        return
      }

      connectedSocket.close()
    }
  }, [userId, sessionId])

  return (
    <WebSocketContext.Provider value={socket}>
      {children}
    </WebSocketContext.Provider>
  )
}